// Vue
import { Vue, Component, Prop, Watch, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";

// Components
import { Button } from "../button/Button";
import { Icon } from "../icon/Icon";
import { P } from "../p/P";
import { Video } from "../video/Video";
import { getCookie } from "../../../utils/cookie";

@Component({
  name: "LightboxVideo",
  components: {
    Button,
    Icon,
    P,
    MgsVideo: Video,
  },
  mixins: [template],
})
export class LightboxVideo extends Vue {
  public isModalOpen: boolean = false;

  public marketingCookies: string[] = [];

  @Prop()
  public videoSrc!: string;

  @Prop()
  public videoPoster!: string;

  @Prop()
  public title!: string;

  @Prop({ default: undefined })
  public visible!: boolean;

  @Prop()
  public openIcon!: string;

  @Watch("visible")
  public watchVisible(visible) {
    if (this.isModalOpen != this.visible) this.isModalOpen = this.visible;
  }

  get isYoutubeCookieAccepted() {
    return this.marketingCookies.includes("youtube");
  }

  get videoStyle() {
    return this.isYoutubeCookieAccepted && { "pointer-events": "none" };
  }

  public $refs!: {
    modal: any;
  };

  public created() {
    this.isModalOpen = this.visible;
  }

  public mounted() {
    this.marketingCookies = getCookie("marketing-cookies") ? JSON.parse(getCookie("marketing-cookies")) : [];
  }

  public destroyed() {}

  public handleOpen(e?: Event) {
    this.isModalOpen = true;

    this.$emit("update:visible", true);
  }

  public handleClose(e?: any) {
    this.isModalOpen = false;

    this.$emit("update:visible", false);
  }

  @Inject({ from: "CI2019HandleFooterClick" })
  public handleFooterClick;

  public onMoreInfo() {
    if (this.handleFooterClick) {
      this.handleFooterClick("cookies");
    }
    this.handleClose();

    this.$emit("moreInfo");
  }

  onCookieAccept() {
    this.marketingCookies = getCookie("marketing-cookies") ? JSON.parse(getCookie("marketing-cookies")) : [];
  }
}
